import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _ from 'lodash';
import InfluencerContextBar from '../../components/influencer-context-bar';
import InfluencerInfoBar from '../../components/influencer-info-bar';

import AudienceDataRequestModal from '../../components/audience-data-request-modal';

import hasJSONAPIClient from '../../hocs/has-jsonapi-client';
import hasUserInfo from '../../hocs/has-user-info';

import {
  DATA_REQUESTS_RESOURCE,
  INFLUENCER_RESOURCE,
  ORGANISATION_RESOURCE,
} from '../../utils/helpers/resources';

const AUDIENCE_TYPE = 'AUDIENCE';
const STATUS_PENDING = 'PENDING';

class InfluencerPage extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      influencer: null,
      influencerDetails: null,
      isLoaded: false,
      isLoading: true,
      isError: false,
      adrModalOpen: false,
      selectedPlatforms: [],
      dataPermission: null,
      isLoadingPermission: true,
    };
  }

  componentDidMount() {
    const { params, jsonAPIClient } = this.props;

    const resourcesToLoad = [
      'organisation',
      'influencer',
      'influencer.telegramChannels',
      'influencer.telegramUser',
      'influencerDetails',
      'influencer.statistics',
      'influencerDetails.tags',
      'influencerDetails.businessUnits',
    ];

    jsonAPIClient.get('influencerLink', params.id, {
      include: resourcesToLoad,
    }).then(response => {
      const resource = response.toJSONTree();
      this.setState({
        organisation: resource.organisation,
        influencer: resource.influencer,
        influencerDetails: resource.influencerDetails,
        isLoaded: true,
        isLoading: false,
        isError: false,
      }, this.requestADRPermission);
    });
  }

  reloadDetails = async () => {
    const { jsonAPIClient } = this.props;
    const { influencerDetails } = this.state;
    const response = await jsonAPIClient.get('influencerDetails', influencerDetails.id, {
      include: ['tags'],
    });
    this.setState({
      influencerDetails: response.toJSONTree(),
    });
  }

  updateInfluencer = attributes => {
    this.setState(prevState => ({
      influencer: { ...prevState.influencer, ...attributes },
    }));
  }

  onADRModalStateChanged = () => {
    this.setState(prevState => ({
      adrModalOpen: !prevState.adrModalOpen,
    }));
  }

  onADRPlatformSelected = (event, { name, checked }) => {
    const { selectedPlatforms } = this.state;
    let platforms = _.clone(selectedPlatforms);
    if (!checked && _.includes(platforms, name)) {
      platforms = _.filter(platforms, platform => platform !== name);
    } else {
      platforms.push(name);
    }
    this.setState({
      selectedPlatforms: platforms,
    });
  }

  onSendADRRequestButtonClick = () => {
    const { selectedPlatforms, influencer } = this.state;
    const { jsonAPIClient, userInfo: { organisationId } } = this.props;
    const channels = _.map(selectedPlatforms, platform => ({
      channel: platform,
      handle: _.get(influencer, platform),
    }));
    const dataRequest = jsonAPIClient.create(DATA_REQUESTS_RESOURCE);
    dataRequest.set('requestType', AUDIENCE_TYPE);
    dataRequest.set('requestStatus', STATUS_PENDING);
    dataRequest.set('influencer', {
      type: INFLUENCER_RESOURCE,
      id: influencer.id,
    });
    dataRequest.set('agency', {
      type: ORGANISATION_RESOURCE,
      id: organisationId,
    });
    dataRequest.set('channels', channels);
    dataRequest.sync().then(() => {
      this.setState({
        adrModalOpen: false,
        selectedPlatforms: [],
      });
    });
  }

  requestADRPermission = () => {
    const { jsonAPIClient, userInfo: { organisationId } } = this.props;
    const { influencer: { id: influencerId } } = this.state;
    jsonAPIClient.find(DATA_REQUESTS_RESOURCE, { // eslint-disable-line lodash/prefer-lodash-method
      filter: {
        agency: organisationId,
        influencer: influencerId,
      },
    }).then(response => {
      const permission = response.length > 0 && _.head(response);
      if (permission) {
        this.setState({
          dataPermission: permission.toJSON(),
          isLoadingPermission: false,
        });
      } else {
        this.setState({
          isLoadingPermission: false,
        });
      }
    }).catch(() => {
      this.setState({
        isLoadingPermission: false,
      });
    });
  }

  leftButtonCallback = () => this.context.router.push('/dashboard');

  rightButtonCallback = () => this.context.router.push('/influencer/add');

  render() {
    const {
      influencer,
      influencerDetails,
      isLoaded,
      adrModalOpen,
      isLoadingPermission,
      dataPermission,
      organisation,
    } = this.state;
    const { children, params: { id }, userInfo: { role, organisationId } } = this.props;
    const isInfluencer = role === 'INFLUENCER';
    const otherProps = {
      onReloadDetails: this.reloadDetails,
      onInfluencerUpdated: this.updateInfluencer,
    };
    return (
      <div className="page">
        <InfluencerContextBar
          rightButtonCallback={this.rightButtonCallback}
          leftButtonCallback={this.leftButtonCallback}
          leftButtonLabel="Create A Campaign"
          rightButtonLabel="Add An Influencer"
          title="Back"
        />
        {
          influencer && isLoaded &&
          <InfluencerInfoBar
            influencer={influencer}
            influencerDetails={influencerDetails}
            withBlogosphereTab={influencerDetails.blogosphereData}
            onADRModalStateChanged={this.onADRModalStateChanged}
            id={id}
            isLoadingPermission={isLoadingPermission}
            dataPermission={dataPermission}
            organisationId={organisationId}
            organisation={organisation}
          />
        }
        {
          adrModalOpen && !isInfluencer &&
          <AudienceDataRequestModal
            onClose={this.onADRModalStateChanged}
            onPlatformSelected={this.onADRPlatformSelected}
            onSendADRRequestButtonClick={this.onSendADRRequestButtonClick}
            influencer={influencer}
          />
        }
        { influencer && isLoaded && children && React.cloneElement(children, this.state, { ...otherProps, ...this.props }) }
      </div>
    );
  }
}

InfluencerPage.propTypes = {
  params: PropTypes.object.isRequired,
  jsonAPIClient: PropTypes.object.isRequired,
  children: PropTypes.any.isRequired,
  userInfo: PropTypes.object.isRequired,
};

export default compose(
  hasJSONAPIClient,
  hasUserInfo,
)(InfluencerPage);



/** WEBPACK FOOTER **
 ** ./src/containers/influencer-page/index.js
 **/